import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTooltipModule } from '@freud-ds/web-components';

import { JourneyAppointmentIconComponent } from './journey-appointment-icon.component';

@NgModule({
	declarations: [JourneyAppointmentIconComponent],
	imports: [CommonModule, FreudTooltipModule],
	exports: [JourneyAppointmentIconComponent],
})
export class JourneyAppointmentIconModule {}
